import { render, staticRenderFns } from "./TemplateGroupEdition.vue?vue&type=template&id=21da4026&scoped=true&"
import script from "./TemplateGroupEdition.vue?vue&type=script&lang=js&"
export * from "./TemplateGroupEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da4026",
  null
  
)

export default component.exports